import {
  PAGEFIRSTICON,
  PAGELASTICON,
  PAGENEXTICON,
  PAGEPREVIOUSICON,
} from "../../Utils/icons";

export default function PageBar(props) {
  const page = parseInt(props.page);
  const loadPrevious = () => {
    props.loadPrevious();
  };
  const loadNext = () => {
    props.loadNext();
  };
  const loadFirst = () => {
    props.loadFirst();
  };
  const loadLast = () => {
    props.loadLast();
  };
  return (
    <>
      <div className="pageToolBar">
        <ul>
          <li onClick={loadFirst}>
            <i>
              <PAGEFIRSTICON />
            </i>
          </li>
          <li onClick={loadPrevious}>
            <i>
              <PAGEPREVIOUSICON />
            </i>
          </li>
          <li>
            <a>{page}</a>
          </li>
          <li onClick={loadNext}>
            <i>
              <PAGENEXTICON />
            </i>
          </li>
          <li onClick={loadLast}>
            <i>
              <PAGELASTICON />
            </i>
          </li>
        </ul>
      </div>
    </>
  );
}
